<template lang="pug">
.alert.alert-danger
  h3.site-title
    | {{label}}
  div
    | エラーが発生したため、このページはシミュレーションできませんでした。
  div
    small {{error}}
  .m-t-20
    a.btn.btn-danger(href="/v3/")
      i.mdi.mdi-arrorw-left.m-r-5
      | URLを修正する

</template>

<script>
export default {
  components: {
  },
  props: {
    label: String,
    error: String,
  },
}
</script>